import { Suspense } from 'react';
import { DataTable, DataTableSkeleton } from './DataTable';
import { Anzeige } from '@/domain/controlling/entities/tagebuchAnzeige';

export function TableWrapper({
  year,
  month,
  umsatzplanungAnzeige,
}: {
  year: number;
  month: number;
  umsatzplanungAnzeige: Anzeige;
}) {
  return (
    <Suspense
      fallback={
        <DataTableSkeleton umsatzplanungAnzeige={umsatzplanungAnzeige} />
      }>
      <DataTable
        umsatzplanungAnzeige={umsatzplanungAnzeige}
        year={year}
        month={month}
      />
    </Suspense>
  );
}
